/* Seasonal dress-up. Halloween runs Oct 1–31, Christmas Dec 1–31; both retire
   themselves — nothing to switch off. */
export function isHalloween(d = new Date()) {
  return d.getMonth() === 9; // October, visitor's local time
}

export function isChristmas(d = new Date()) {
  return d.getMonth() === 11; // December
}

export function currentSeason(d = new Date()) {
  if (isChristmas(d)) return "christmas";
  if (isHalloween(d)) return "halloween";
  return null;
}
